import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { filterFilesByType } from '../../../helpers';
import { FILE_TYPE_IDS } from '../../../constants';
import { fetchImageUrls } from '../../../reducers/patients';
import { sortNewestCallback } from '../../../helpers/patientFiles';
import Modal from '../../../components/CustomReactImages/Modal';

const ImageGallery = ({ images, fetching, fetchImages, onClose }) => {
  useEffect(() => {
    if (fetching || images.length > 0) return;
    fetchImages();
  }, [fetching, images.length, fetchImages]);

  return <Modal images={images} onClose={onClose} />;
};

ImageGallery.propTypes = {};

export default connect(
  (state, { patient }) => {
    const updatedPatient = state.patients.items.find(p => p.id === patient.id);

    const bracketImages =
      !updatedPatient.files || !updatedPatient.files[FILE_TYPE_IDS.brackets]
        ? []
        : [...updatedPatient.files[FILE_TYPE_IDS.brackets]];

    bracketImages.sort(sortNewestCallback);

    const images = bracketImages.map(file => ({ src: file.url }));

    return {
      patient,
      fetching: state.patients.fetchingImages.includes(patient.id),
      images
    };
  },
  (dispatch, { patient }) => {
    return {
      fetchImages: () =>
        dispatch(
          fetchImageUrls(
            patient.id,
            FILE_TYPE_IDS.brackets,
            filterFilesByType(patient.patient_files, FILE_TYPE_IDS.brackets).map(i => i.id)
          )
        )
    };
  }
)(ImageGallery);
